import Alert from '@shared/components/Alert.tsx';
import { AlertElementElementModel, ApiBlockListModel } from '@shared/integrations/umbraco-taf-delivery-api/models';

interface IAlertsProps {
    alerts: ApiBlockListModel;
}

const Alerts = ({ alerts }: IAlertsProps) => {
    return (
        <>
            {alerts?.items && (
                <div>
                    {alerts.items?.map((item) => {
                        if (!item.content) return;
                        const content = item.content as AlertElementElementModel;
                        return (
                            <Alert
                                key={content?.id}
                                alert={content}
                            />
                        );
                    })}
                </div>
            )}
        </>
    );
};

export default Alerts;
